<template>
    <AdminUserManagement v-if="isAdmin" />
    <EmployeeUserManagement v-else />
</template>
<script>
import AdminUserManagement from "./AdminUserManagement.vue";
import EmployeeUserManagement from "./EmployeeUserManagement.vue";
export default {
    components: {
        AdminUserManagement,
        EmployeeUserManagement
    },
    data() {
        const user = this.$store.state.auth.user;
        return {
            isAdmin: user && user.role === "admin",
        };
    },

};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/userManagement/index.vue